import { ApolloCache } from '@apollo/client';
import {
  CreateDashboardMutation,
  CreateDashboardMutationVariables,
  DashboardViewFragment,
  GetDashboardByTokenDocument,
  GetDashboardByTokenQuery,
  Scope,
  Status,
  UserInfoViewFragment,
} from 'generated/graphql';
import { User } from 'v2/core/entities/user';
import { createCachedDashboardListItem } from './createCachedDashboardListItem';

export const createCachedDashboard = (
  cache: ApolloCache<unknown>,
  result: { data?: CreateDashboardMutation | null | undefined },
  options: { variables?: CreateDashboardMutationVariables },
  user: User,
) => {
  if (!options.variables) {
    return;
  }

  const dashboard = result.data?.createDashboard;
  if (!dashboard) {
    return;
  }

  const {
    title,
    scope = Scope.Public,
    metadata,
    shortMetadata = '',
  } = options.variables;

  const now = Math.floor(Date.now() / 1000);

  const createdBy: UserInfoViewFragment = {
    __typename: 'UserInfo',
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
  };

  const dashboardViewFragment: DashboardViewFragment = {
    __typename: 'Dashboard',
    id: dashboard.id,
    viewToken: dashboard.viewToken,
    editToken: dashboard.editToken,
    title,
    scope,
    metadata,
    shortMetadata,
    createdBy,
    tenantID: user.tenant.id,
    description: '',
    createdAt: now,
    updatedAt: now,
    isReportingDisabled: false,
    status: Status.Unarchived,
    widgets: [],
    editors: [],
    version: dashboard.dashboard.version,
  };

  const data: GetDashboardByTokenQuery = {
    getDashboardByToken: dashboardViewFragment,
  };

  cache.writeQuery({
    query: GetDashboardByTokenDocument,
    variables: {
      token: dashboard.viewToken,
      userID: user.id,
      tenantID: user.tenant.id,
      includeScheduleOutbounds: true,
    },
    data: {
      ...data,
      reporting: null,
      originDashboard: null,
    },
  });

  createCachedDashboardListItem(cache, dashboardViewFragment, user);
};
